// extracted by mini-css-extract-plugin
export default {"loadingSpinContainer":"_loadingSpin_loadingSpinContainer__lyVkJ","spinner":"_loadingSpin_spinner__jjIU-","spin":"_loadingSpin_spin__qi15v"};